import apiCrud from '../../abstract/api-crud';

const baseUri = `${ import.meta.env.VITE_SITE_URL }/staffs/leaves`;
export const modelName = 'leave';

export default {
  ...apiCrud({ baseUri, modelName }),
};
